module.exports = __webpack_public_path__ + "assets/15638157789810f5a8fb41fdd9f130db.png";